import * as React from 'react';
import { useEffect } from 'react';
import { useUserManager } from './UserManagerProvider';
import { log } from '../../../logConfig';
import { useHistory } from 'react-router';
import { HOME_MAPPING } from '../../components/router/AppRouter';
import { captureMessage, Severity } from '@sentry/react';

export function RedirectCallback(props: {}) {
  const {userManager} = useUserManager();
  const history = useHistory();

  useEffect(() => {
    if (userManager) {
      userManager.signinRedirectCallback().then((user) => {
        log.debug('Inside Redirect Callback: Got user and forwarding to home... user: ' + JSON.stringify(user));
        history.push(HOME_MAPPING);
      }).catch((error) => {
        captureMessage('RedirectCallback: Could not retrieve user: ' + JSON.stringify(error), Severity.Info);
        log.info('Could not retrieve user: ' + JSON.stringify(error));
        userManager.removeUser().then(() => userManager.clearStaleState()).then(() => userManager.signinRedirect());
      });
    }
  });

  return (
    <div>
      <h3>Login wird abgeschlossen...</h3>
      <p>Sie werden in wenigen Augenblicken weiter geleitet. Falls nicht, können Sie sich hier auch erneut anmelden:</p>
      <button type="button" onClick={() => {
        userManager?.signinRedirect().then();
      }}>
        Anmelden
      </button>
    </div>
  );
}
